import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { Role } from './shared/role';
import { RoleRedirectGuard } from './shared/guards/roleRedirect.guard';
import { RedirectComponent } from './components/redirect/redirect.component';

const routes: Routes = [
  // {
  //   path: 'home',
  //   loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  // },
  // {
  //   path: 'message/:id',
  //   loadChildren: () => import('./view-message/view-message.module').then( m => m.ViewMessagePageModule)
  // },
  {
    path: '',
    component: RedirectComponent, // Optional: shows "Redirecting..." message
    canActivate: [RoleRedirectGuard]
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./ui-pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'main',
    loadChildren: () => import('./ui-pages/main/main.module').then( m => m.MainPageModule),
    canActivate: [AuthGuard],
    data: {
      activeRoles: [Role.SystemAdmin, Role.Client, Role.ClientStaff, Role.ClientMirror,
        Role.ClientAdminViewOnly, Role.ClientHR, Role.ClientTimesheet, Role.ClientReport
      ]
    }
  },
  {
    path: 'login',
    loadChildren: () => import('./ui-pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./ui-pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'not-found',
    loadChildren: () => import('./ui-pages/not-found/not-found.module').then( m => m.NotFoundPageModule)
  },
  {
    path: 'knight',
    loadChildren: () => import('./ui-pages/knight/knight.module').then( m => m.KnightPageModule),
    canActivate: [AuthGuard],
    data: {
      activeRoles: [Role.Knight, Role.Seeker]
    }
  },
  {
    path: 'full-screen',
    loadChildren: () => import('./ui-pages/full-screen/full-screen.module').then( m => m.FullScreenPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'permissions',
    loadChildren: () => import('./ui-pages/permissions/permissions.module').then( m => m.PermissionsPageModule)
  },
  {
    path: 'koperasi',
    loadChildren: () => import('./ui-pages/select-coperasi/select-coperasi.module').then( m => m.SelectCoperasiPageModule), 
    canActivate: [AuthGuard],
    data: {
      activeRoles: [Role.Knight, Role.Client, Role.ClientStaff, Role.ClientMirror, Role.ClientAdminViewOnly]
    }
  },
  {
    path: 'privacy',
    loadChildren: () => import('./ui-pages/privacy/privacy.module').then( m => m.PrivacyPageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./ui-pages/privacy/privacy.module').then( m => m.PrivacyPageModule)
  },
  {
    path: 'delete-account',
    loadChildren: () => import('./ui-pages/delete-account/delete-account.module').then( m => m.DeleteAccountPageModule)
  },
  {
    path: 'admin-fullscreen',
    loadChildren: () => import('./ui-pages/admin-fullscreen/admin-fullscreen.module').then( m => m.AdminFullscreenPageModule),
    canActivate: [AuthGuard],
    data: {
      activeRoles: [Role.SystemAdmin, Role.Client, Role.ClientStaff, Role.ClientMirror,Role.ClientHR, Role.ClientAdminViewOnly, Role.ClientTimesheet, Role.ClientReport]
    }
  },
  {
    path: 'welcome',
    loadChildren: () => import('./ui-pages/welcome/welcome.module').then( m => m.WelcomePageModule),
    canActivate: [AuthGuard],
    data: {
      activeRoles: [Role.SystemAdmin, Role.Client, Role.ClientStaff, Role.ClientMirror,
        Role.ClientHR, Role.ClientAdminViewOnly, Role.ClientTimesheet, Role.ClientReport
      ]
    }
  },
  {
    path: 'user-guides',
    loadChildren: () => import('./ui-pages/user-guides/user-guides.module').then( m => m.UserGuidesPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
